import { createContext } from 'react';

export interface MenuContextProps {
  isOpen: boolean;
  setOpen: () => void;
  setClosed: () => void;
}

export const MenuContext = createContext<MenuContextProps | undefined>(
  undefined
);
